module.exports = __webpack_public_path__ + "code.fbc81ec4.png";